import { render } from "./BaseModal.vue?vue&type=template&id=742b9a28&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=742b9a28&lang=scss&scoped=true"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742b9a28"]])

export default __exports__